import { render, staticRenderFns } from "./privateWkApp.vue?vue&type=template&id=4fabe164"
import script from "./privateWkApp.vue?vue&type=script&lang=js"
export * from "./privateWkApp.vue?vue&type=script&lang=js"
import style0 from "./privateWkApp.vue?vue&type=style&index=0&id=4fabe164&prod&lang=css"
import style1 from "./privateWkApp.vue?vue&type=style&index=1&id=4fabe164&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports